<template>
  <v-form ref="branchEditForm" v-model="valid">
    <div class="back-btn" @click="$router.push({name: 'delivery-index', params: {tab: 2}})">
      <svg width="56" height="56" viewBox="0 0 56 56" fill="none" xmlns="http://www.w3.org/2000/svg">
        <path d="M36 27H23.83L29.42 21.41L28 20L20 28L28 36L29.41 34.59L23.83 29H36V27Z" fill="#8C959D"/>
      </svg>
    </div>
    <v-row>
      <v-col cols="12" sm="5" md="4" xl="3">
        <h1 class="mb-16">{{ branch.id ? 'Редактировать филиал' : 'Создать филиал' }}</h1>
        <v-text-field
            v-model="branch.name"
            label="Название"
            :rules="[rules.required]"
            required
            outlined
        ></v-text-field>
        <v-tabs v-model="tabLang">
          <v-tab>RU</v-tab>
          <v-tab>UA</v-tab>
        </v-tabs>
        <v-tabs-items v-model="tabLang" class="pt-5">
          <v-tab-item>
            <v-text-field
                v-model="branch.self_delivery_name"
                label="Название для самовывоза"
                :rules="[rules.required]"
                required
                outlined
            ></v-text-field>
            <v-text-field
                v-model="branch.self_delivery_address"
                label="Адрес для самовывоза"
                :rules="[rules.required]"
                required
                outlined
            ></v-text-field>
          </v-tab-item>
          <v-tab-item>
            <v-text-field
                v-model="branch.self_delivery_name_ua"
                label="Название для самовывоза"
                :rules="[rules.required]"
                required
                outlined
            ></v-text-field>
            <v-text-field
                v-model="branch.self_delivery_address_ua"
                label="Адрес для самовывоза"
                :rules="[rules.required]"
                required
                outlined
            ></v-text-field>
          </v-tab-item>
        </v-tabs-items>


        <v-checkbox
            dense
            hide-details
            v-model="branch.is_self_delivery"
            label="Самовывоз"
            class="mb-5"
        >
        </v-checkbox>

        <v-btn :loading="loadingButton" v-if="id" @click="update">Сохранить</v-btn>
        <v-btn :loading="loadingButton" v-else @click="create">Создать</v-btn>
      </v-col>
      <v-snackbar
          v-model="snackbar"
          :timeout="timeout"
          :color="snackbarColor"
          right
          top
      >
        {{ snackbarText }}
      </v-snackbar>
    </v-row>
  </v-form>
</template>

<script>
// @ is an alias to /src
import BranchService from "../../../api/BranchService";
import moment from 'moment'

export default {
  name: 'BranchEdit',
  props: {
    id: {
      default: null,
    }
  },
  components: {},
  data: () => ({
    snackbar: false,
    timeout: 2000,
    snackbarText: '',
    snackbarColor: '',
    timeModal: false,
    valid: true,
    rules: {
      required: value => !!value || 'Нужно заполнить',
      requiredSelect: v => {
        return !!v.id || 'Нужно заполнить'
      },
    },
    tabLang: '',
    branch: {
      name: '',
      default_delivery_time: '00:00',
      delivery_time: '00:00',
      self_delivery_name: '',
      self_delivery_name_ua: '',
      self_delivery_address: '',
      self_delivery_address_ua: '',
      is_self_delivery: false,

    },
    loading: true,
    loadingButton: false,
  }),
  mounted() {
    this.init()
  },
  methods: {
    validate() {
      this.$refs.branchEditForm.validate()
    },
    init() {
      if (this.id) {
        BranchService.get(this.id)
            .then(response => {
              this.branch = response.data;
              this.loading = false
            });
      }
    },
    update() {
      this.validate()
      if (!this.valid) {
        return false
      }
      this.loadingButton = true;
      let formData = this.getData();

      BranchService.update(formData).then(response => {
        this.snackbar = true;
        this.snackbarText = 'Филиал успешно обновлен';
        this.snackbarColor = 'success';
      }).catch(error => {
        this.snackbar = true;
        this.snackbarText = 'Ошибка при обновлении филиала';
        this.snackbarColor = 'error';
      }).finally(() => {
        this.loadingButton = false
      })
    },
    create() {
      this.validate()
      if (!this.valid) {
        return false
      }
      this.loadingButton = true;
      var formData = this.getData();

      BranchService.create(formData).then(response => {
        this.snackbar = true;
        this.snackbarText = 'Филиал успешно создан';
        this.snackbarColor = 'success';
        this.$router.push({name: 'branch-edit', params: {id: response.data.id}})
        this.init();
      }).catch(error => {
        this.snackbar = true;
        this.snackbarText = 'Ошибка при создании филиала';
        this.snackbarColor = 'error';
      }).finally(() => {
        this.loadingButton = false
      })
    },
    getData() {
      let formData = new FormData();
      let time = moment('2020-01-01 ' + this.branch.default_delivery_time).format('HH:mm:ss')

      formData.append('id', this.id);
      formData.append('name', this.branch.name);
      formData.append('self_delivery_name', this.branch.self_delivery_name);
      formData.append('self_delivery_name_ua', this.branch.self_delivery_name_ua);
      formData.append('self_delivery_address', this.branch.self_delivery_address);
      formData.append('self_delivery_address_ua', this.branch.self_delivery_address_ua);
      formData.append('is_self_delivery', this.branch.is_self_delivery ? 1 : 0);
      formData.append('default_delivery_time', '2020-01-01 00:00:00');
      formData.append('delivery_time', '2020-01-01 00:00:00');

      return formData;
    }
  },
}
</script>

<style scoped lang="scss">
.image-placeholder {
  width: 100%;
  height: 100%;
  background-color: #F3F7FC;
  border-radius: 4px;
}

.branch-images .v-image {
  max-height: 374px;
}

.branch {
  position: relative;

  &:before {
    content: "";
    padding-top: 100%;
    display: block;
  }

  .content {
    position: absolute;
    width: 100%;
    left: 0;
    top: 0;
    height: 100%;
    background-color: #F8FBFF;
    border-right-style: 3px;

    .img {
      height: 3.541vw;
      margin-top: .83vw;
    }

    .name {
      margin-top: .72vw;
      text-align: center;
      color: #8C959D;
    }
  }
}
</style>
